export const generateTemplateName = (param: string) => {
  if (!param?.includes('(Copy)')) return `${param + ' (Copy)'}`;
  //Split splitTemplateName String and copy count Integer
  const splitTemplateName = param.split(/(\d+)/);
  const templateNameString = splitTemplateName[0];
  const copyCount = splitTemplateName[1];
  if (copyCount) return `${templateNameString + (parseInt(copyCount) + 1)}`;
  else return `${templateNameString} 2`;
};
